import { Box, Divider, Grid, Typography } from "@mui/material";
import ChipColor from "../../scenes/remediation/plan/components/ChipColor";

/**
 * Demonstration of ChipColor component showing different types and variations
 * using actual chip data from utils/chipsData.js
 */
const ChipColorDemo = () => {
  return (
    <Box sx={{ width: "100%" }}>
      {/* Entity Risk Examples */}
      <Typography variant="h6" gutterBottom>
        Entity Risk Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="entity_risk" value={1} />
        </Grid>
        <Grid item>
          <ChipColor type="entity_risk" value={2} />
        </Grid>
        <Grid item>
          <ChipColor type="entity_risk" value={3} />
        </Grid>
        <Grid item>
          <ChipColor type="entity_risk" value={4} />
        </Grid>
        <Grid item>
          <ChipColor type="entity_risk" value={5} />
        </Grid>
      </Grid>

      {/* Tenant Risk Examples */}
      <Typography variant="h6" gutterBottom>
        Tenant Risk Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="tenant_risk" value="Low" />
        </Grid>
        <Grid item>
          <ChipColor type="tenant_risk" value="Medium" />
        </Grid>
        <Grid item>
          <ChipColor type="tenant_risk" value="High" />
        </Grid>
        <Grid item>
          <ChipColor type="tenant_risk" value="Critical" />
        </Grid>
      </Grid>

      {/* Remediation Status Examples */}
      <Typography variant="h6" gutterBottom>
        Status Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="status" value="Resolved" />
        </Grid>
        <Grid item>
          <ChipColor type="status" value="In Progress" />
        </Grid>
        <Grid item>
          <ChipColor type="status" value="Pending" />
        </Grid>
      </Grid>

      {/* Complexity Examples */}
      <Typography variant="h6" gutterBottom>
        Complexity Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="complexity" value={1} />
        </Grid>
        <Grid item>
          <ChipColor type="complexity" value={2} />
        </Grid>
        <Grid item>
          <ChipColor type="complexity" value={3} />
        </Grid>
      </Grid>

      {/* Feasibility Examples */}
      <Typography variant="h6" gutterBottom>
        Feasibility Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="feasibility" value={1} />
        </Grid>
        <Grid item>
          <ChipColor type="feasibility" value={2} />
        </Grid>
        <Grid item>
          <ChipColor type="feasibility" value={3} />
        </Grid>
        <Grid item>
          <ChipColor type="feasibility" value={4} />
        </Grid>
        <Grid item>
          <ChipColor type="feasibility" value={5} />
        </Grid>
      </Grid>

      {/* Impact Examples */}
      <Typography variant="h6" gutterBottom>
        Impact Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="impact" value={1} />
        </Grid>
        <Grid item>
          <ChipColor type="impact" value={2} />
        </Grid>
        <Grid item>
          <ChipColor type="impact" value={3} />
        </Grid>
        <Grid item>
          <ChipColor type="impact" value={4} />
        </Grid>
        <Grid item>
          <ChipColor type="impact" value={5} />
        </Grid>
      </Grid>

      {/* Control Priority Examples */}
      <Typography variant="h6" gutterBottom>
        Control Priority Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="controlPriority" value={0} />
        </Grid>
        <Grid item>
          <ChipColor type="controlPriority" value={1} />
        </Grid>
        <Grid item>
          <ChipColor type="controlPriority" value={2} />
        </Grid>
        <Grid item>
          <ChipColor type="controlPriority" value={3} />
        </Grid>
      </Grid>

      {/* Coverage Examples */}
      <Typography variant="h6" gutterBottom>
        Coverage Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="coverage" value={1} />
        </Grid>
        <Grid item>
          <ChipColor type="coverage" value={2} />
        </Grid>
        <Grid item>
          <ChipColor type="coverage" value={3} />
        </Grid>
        <Grid item>
          <ChipColor type="coverage" value={4} />
        </Grid>
        <Grid item>
          <ChipColor type="coverage" value={5} />
        </Grid>
      </Grid>

      {/* Risk Examples */}
      <Typography variant="h6" gutterBottom>
        Risk Level Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="risk" value={1} />
        </Grid>
        <Grid item>
          <ChipColor type="risk" value={2} />
        </Grid>
        <Grid item>
          <ChipColor type="risk" value={3} />
        </Grid>
        <Grid item>
          <ChipColor type="risk" value={4} />
        </Grid>
      </Grid>

      {/* Vulnerability Severity Examples */}
      <Typography variant="h6" gutterBottom>
        Vulnerability Severity Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="vulnerabilitySeverity" value="LOW" />
        </Grid>
        <Grid item>
          <ChipColor type="vulnerabilitySeverity" value="MEDIUM" />
        </Grid>
        <Grid item>
          <ChipColor type="vulnerabilitySeverity" value="HIGH" />
        </Grid>
        <Grid item>
          <ChipColor type="vulnerabilitySeverity" value="CRITICAL" />
        </Grid>
      </Grid>

      {/* Breeze Score Examples */}
      <Typography variant="h6" gutterBottom>
        Breeze Score Chips
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="breezeScore" value={2} />
        </Grid>
        <Grid item>
          <ChipColor type="breezeScore" value={4.5} />
        </Grid>
        <Grid item>
          <ChipColor type="breezeScore" value={7} />
        </Grid>
        <Grid item>
          <ChipColor type="breezeScore" value={9} />
        </Grid>
      </Grid>

      <Divider sx={{ my: 4 }} />

      {/* Size Variations */}
      <Typography variant="h6" gutterBottom>
        Size Variations
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="entity_risk" value={3} size="small" />
        </Grid>
        <Grid item>
          <ChipColor type="entity_risk" value={3} size="medium" />
        </Grid>
        <Grid item>
          <ChipColor type="entity_risk" value={3} size="large" />
        </Grid>
      </Grid>

      {/* Other Variations */}
      <Typography variant="h6" gutterBottom>
        Other Variations
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item>
          <ChipColor type="entity_risk" value={4} disabled />
        </Grid>
        <Grid item>
          <ChipColor
            type="entity_risk"
            value={4}
            width={120}
            labelWidth={true}
          />
        </Grid>
        <Grid item>
          <ChipColor type="entity_risk" value={4} defaultColor />
        </Grid>
        <Grid item>
          <ChipColor type="entity_risk" value={4} useShortLabel={true} />
        </Grid>
      </Grid>

      {/* Non-typed Examples */}
      <Typography variant="h6" gutterBottom>
        Generic Value Chips
      </Typography>
      <Grid container spacing={2}>
        <Grid item>
          <ChipColor value="14 Days" size="small" labelWidth={true} />
        </Grid>
        <Grid item>
          <ChipColor value="75%" size="small" labelWidth={true} />
        </Grid>
        <Grid item>
          <ChipColor value="Custom Value" labelWidth={true} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ChipColorDemo;
